import Modal from "react-modal";
import crossImage from "../../images/singleinvoice/cross-red.svg";
import tickImage from "../../images/singleinvoice/tick-green.svg";

const GoogleTokenInvalidModal = ({
    isGoogleTokenInvalidModalOpen,
    setIsGoogleTokenInvalidModalOpen,
    user,
    isGoogleTokenChecking,
}) => {
    const handleReauthenticate = () => {
        const origin = `${window.location.origin}/user/calendar`;
        const userId = user?._id;
        const baseUrl = window.location.origin.includes("localhost:3000")
            ? "http://localhost:8090"
            : window.location.origin;
        const url = `${baseUrl}/google?origin=${encodeURIComponent(origin || '')}&userId=${encodeURIComponent(userId || '')}`;
        if (origin && userId) {
            window.open(url, '_self');
        } else {
            console.error('Origin or userId missing for re-authentication');
        }
    };

    return (
        <Modal
            className="client-modal sprint-modal time-off-review date-event-calendar-modal"
            isOpen={isGoogleTokenInvalidModalOpen}
            onRequestClose={() => {
                if (!isGoogleTokenChecking) {
                    setIsGoogleTokenInvalidModalOpen(false);
                }
            }}
            contentLabel="Re-authenticate Google Calendar"
            style={{
                content: {
                    height: 'auto',
                    width: '30%',
                    maxWidth: '400px',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    overflowY: 'auto',
                    maxHeight: '50vh',
                },
            }}
        >
            <div className="modal timeoff-review">
                <div className="modal-inner-top-sec">
                    <div className="modal-close-invite outter-modal-main">
                        <a
                            onClick={() => {
                                if (!isGoogleTokenChecking) {
                                    setIsGoogleTokenInvalidModalOpen(false);
                                }
                            }}
                            disabled={isGoogleTokenChecking}
                        >
                            <img src={crossImage} alt="Close Icon" />
                        </a>
                    </div>
                    <div className="modal-client-head">
                        <h2>Google Calendar Authentication Required</h2>
                    </div>
                </div>
                <div className="form-field-client-outer-main">
                    <p style={{ fontSize: '14px', color: '#2c3e50', marginBottom: '15px' }}>
                        Your Google Calendar access token is invalid or integration is not enabled. Please re-authenticate to fetch your events.
                    </p>
                    <div
                        className="form-field-client-btns timeoff-btn"
                        style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'center',
                        }}
                    >
                        <button
                            className="action-btn modal-btn-calendar approve"
                            onClick={handleReauthenticate}
                            disabled={isGoogleTokenChecking}
                        >
                            Re-authenticate
                            <img src={tickImage} alt="Authenticate" />
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default GoogleTokenInvalidModal;